<template>

</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { warningNotification, infoNotification } from '../notifications'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    props: [
      'reason'
    ],
    data () {
      return {
        oneSidedMessage: 'The other party will not be recorded due to your organization privacy settings.',
        promptMessage: 'This number requires consent from the other party before recording the call.',
        teamDisabledMessage: 'Recording this number has been disabled by your organization.'
      }
    },
    computed: {
      isPrompt () {
        return this.reason === 'prompt'
      },
      isTeamDisabled () {
        return this.reason === 'restrict'
      },
      isOneSided () {
        return this.reason === 'restrict-one-side'
      }
    },
    mounted () {
      if (this.isPrompt) {
        warningNotification({message: this.promptMessage}).show()

        this.markRecordingState('off')
      }

      if (this.isTeamDisabled) {
        infoNotification({message: this.teamDisabledMessage}).show()

        this.markRecordingState('off')
        this.markRecordingButtonDisabled(true)
      }

      if (this.isOneSided) {
        infoNotification({message: this.oneSidedMessage}).show()
      }
    },
    methods: {
      ...mapActions([
        'markRecordingState',
        'markRecordingButtonDisabled'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// RecordingMessage.vue?6b62e358